<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout container align-center justify-center wrap rows>
        <v-flex xs-12>
          <v-card flat>
            <v-card-title>
              <v-img :src="logo"/>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data () {
    return {
      logo: require('@/assets/leapq-logo.jpg')
    }
  }
}
</script>

<style scoped>
  .v-card {
    padding: 50px;
  }

  .v-image {
    margin: auto;
    max-width: 500px;
  }

  .headline {
    font-size: 36px !important;
    margin: auto;
    text-align: center;
  }
</style>
